<template>
    <div class="archive-detail-page" v-title :data-title="title">
        <el-container class="archive-detail-container">
            <el-main>
                <!-- 返回链接 -->
                <div class="archive-detail-nav">
                    <router-link to="/archives" class="back-link">
                        <i class="el-icon-arrow-left"></i> 返回文章归档
                    </router-link>
                </div>

                <!-- 标题区 -->
                <div class="archive-detail-title cyber-glass-header">
                    <div class="archive-detail-icon-wrap">
                        <svg class="archive-detail-icon" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                            <rect x="8" y="12" width="48" height="44" rx="4" fill="none" stroke="currentColor" stroke-width="2"/>
                            <line x1="8" y1="24" x2="56" y2="24" stroke="currentColor" stroke-width="2"/>
                            <line x1="20" y1="8" x2="20" y2="20" stroke="currentColor" stroke-width="2"/>
                            <line x1="44" y1="8" x2="44" y2="20" stroke="currentColor" stroke-width="2"/>
                            <line x1="20" y1="36" x2="44" y2="36" stroke="currentColor" stroke-width="1.5"/>
                            <line x1="20" y1="44" x2="36" y2="44" stroke="currentColor" stroke-width="1.5"/>
                        </svg>
                    </div>
                    <h3 class="archive-detail-name">{{ year }}年{{ month }}月</h3>
                    <span class="archive-detail-meta">共 {{ articleCount }} 篇文章</span>
                </div>

                <!-- 快速切换年月（与总览页保持一致尺寸） -->
                <div class="archive-detail-selector">
                    <el-select v-model="selectedYear" placeholder="年份" class="archive-detail-select archive-detail-select-year" @change="goToSelected">
                        <el-option v-for="y in yearOptions" :key="y" :label="y + '年'" :value="y"/>
                    </el-select>
                    <el-select v-model="selectedMonth" placeholder="月份" class="archive-detail-select archive-detail-select-month" @change="goToSelected">
                        <el-option v-for="m in 12" :key="m" :label="m + '月'" :value="m"/>
                    </el-select>
                    <el-button class="archive-detail-reset-btn" @click="resetToArchiveList">重置</el-button>
                </div>

                <!-- 文章列表 -->
                <div class="archive-detail-articles">
                    <article-scroll-page :query="query"></article-scroll-page>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import ArticleScrollPage from "@/components/common/ArticleScrollPage"
    import {getArchives} from "@/api/article"

    export default {
        name: "ArchiveDetailPage",
        data() {
            return {
                query: {
                    tagId: null,
                    categoryId: null,
                    year: null,
                    month: null
                },
                articleCount: 0,
                archives: [],
                selectedYear: null,
                selectedMonth: null
            }
        },
        computed: {
            year() {
                return this.$route.params.year || "";
            },
            month() {
                return this.$route.params.month || "";
            },
            title() {
                return `${this.year}年${this.month}月`;
            },
            yearOptions() {
                const years = new Set(this.archives.map(a => a.year));
                if (years.size > 0) {
                    return Array.from(years).sort((a, b) => b - a);
                }
                const currentYear = new Date().getFullYear();
                return Array.from({length: 10}, (_, i) => currentYear - i);
            }
        },
        watch: {
            "$route"(to, from) {
                if (to.params.year !== from.params.year || to.params.month !== from.params.month) {
                    this.updateQuery();
                    this.syncSelectedFromRoute();
                    this.fetchArchiveCount();
                }
            }
        },
        created() {
            this.updateQuery();
            this.syncSelectedFromRoute();
            this.fetchArchiveCount();
        },
        methods: {
            // 路由参数直接当 String 传给接口（后端接收 String 年月）
            updateQuery() {
                const y = this.$route.params.year;
                const m = this.$route.params.month;
                this.query = {
                    tagId: null,
                    categoryId: null,
                    year: y || null,
                    month: m || null
                };
            },
            fetchArchiveCount() {
                getArchives().then((res) => {
                    if (res.data.success && res.data.data) {
                        this.archives = res.data.data;
                        const found = this.archives.find(
                            a => String(a.year) === this.year && String(a.month) === this.month
                        );
                        this.articleCount = found ? found.count : 0;
                    }
                }).catch(() => {});
            },
            syncSelectedFromRoute() {
                const y = this.$route.params.year;
                const m = this.$route.params.month;
                const numY = parseInt(y, 10);
                const numM = parseInt(m, 10);
                this.selectedYear = (y && !isNaN(numY)) ? numY : null;
                this.selectedMonth = (m && !isNaN(numM) && numM >= 1 && numM <= 12) ? numM : null;
            },
            goToSelected() {
                if (this.selectedYear && this.selectedMonth) {
                    this.$router.push({path: `/archives/${this.selectedYear}/${this.selectedMonth}`});
                }
            },
            resetToArchiveList() {
                this.$router.push({path: "/archives"});
            }
        },
        components: {
            "article-scroll-page": ArticleScrollPage
        }
    }
</script>

<style scoped>
    .archive-detail-page {
        margin: 40px auto 56px;
        min-width: 100%;
    }

    .archive-detail-container {
        max-width: 900px;
        margin: 0 auto;
    }

    .archive-detail-container .el-main {
        padding: 0;
    }

    .archive-detail-nav {
        margin-bottom: 16px;
    }

    .archive-detail-nav .back-link {
        display: inline-flex;
        align-items: center;
        color: rgba(0, 255, 245, 0.9);
        font-size: 14px;
        text-decoration: none;
        transition: all 0.25s ease;
    }

    .archive-detail-nav .back-link:hover {
        color: #00fff5;
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.5);
    }

    .archive-detail-title.cyber-glass-header {
        text-align: center;
        min-height: 120px;
        padding: 28px 20px;
        background: rgba(10, 15, 28, 0.5);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.2);
        border-radius: 12px;
        margin-bottom: 24px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05);
    }

    .archive-detail-icon-wrap {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
        width: 48px;
        height: 48px;
        border-radius: 10px;
        border: 1px solid rgba(0, 255, 245, 0.35);
        background: rgba(0, 255, 245, 0.06);
        box-shadow: 0 0 12px rgba(0, 255, 245, 0.2);
    }

    .archive-detail-icon {
        width: 28px;
        height: 28px;
        color: #00fff5;
        filter: drop-shadow(0 0 6px rgba(0, 255, 245, 0.5));
    }

    .archive-detail-name {
        font-size: 28px;
        font-weight: 600;
        color: rgba(224, 242, 254, 0.98);
        margin: 0 0 8px 0;
    }

    .archive-detail-meta {
        font-size: 14px;
        color: rgba(148, 163, 184, 0.9);
    }

    .archive-detail-selector {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 20px;
        padding: 16px 20px;
        max-width: 640px;
        background: rgba(10, 15, 28, 0.5);
        backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.2);
        border-radius: 12px;
    }

    .archive-detail-select {
        flex-shrink: 0;
    }

    .archive-detail-select-year {
        width: 140px !important;
        min-width: 140px !important;
    }

    .archive-detail-select-month {
        width: 120px !important;
        min-width: 120px !important;
    }

    .archive-detail-select :deep(.el-input) {
        width: 100% !important;
    }

    .archive-detail-select :deep(.el-input__inner) {
        width: 100% !important;
        min-width: 100% !important;
        box-sizing: border-box;
        background: rgba(0, 255, 245, 0.06) !important;
        border-color: rgba(0, 255, 245, 0.3) !important;
        color: rgba(224, 242, 254, 0.95) !important;
    }

    .archive-detail-select :deep(.el-input__inner:hover),
    .archive-detail-select :deep(.el-input__inner:focus) {
        border-color: rgba(0, 255, 245, 0.6) !important;
    }

    .archive-detail-reset-btn {
        background: transparent !important;
        border-color: rgba(148, 163, 184, 0.5) !important;
        color: rgba(203, 213, 225, 0.9) !important;
    }

    .archive-detail-reset-btn:hover {
        border-color: rgba(0, 255, 245, 0.5) !important;
        color: #00fff5 !important;
    }

    .archive-detail-articles {
        width: 640px;
        max-width: 95vw;
        margin: 0 auto;
    }
</style>

<style>
    /* 非 scoped：强制归档详情页选择框与总览页一致（宽度+高度），并居中 */
    .archive-detail-page .archive-detail-select-year,
    .archive-detail-page .archive-detail-select-year .el-input {
        width: 140px !important;
        min-width: 140px !important;
    }
    .archive-detail-page .archive-detail-select-month,
    .archive-detail-page .archive-detail-select-month .el-input {
        width: 120px !important;
        min-width: 120px !important;
    }
    /* 与总览页相同的输入框高度（Element 默认 size 约 40px） */
    .archive-detail-page .archive-detail-select-year .el-input__inner,
    .archive-detail-page .archive-detail-select-month .el-input__inner {
        height: 40px !important;
        line-height: 40px !important;
    }
</style>
